import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore, useUserStore } from '@/store';


import { DEFAULT_HOUSE_PREVIEW } from '@/common/utils';
import { getSqftText } from '@/common/house';
import { numberFormat } from '@/common/format';
import VerifyMask from '../../verify-mask.vue';
import PriceMask from '../../title-mask.vue'
import { buildUrl } from '@/router/index.js';

export default {
    i18next: {
        ns: 'md-listing-list'
    },
    data: function() {
        return {
            errorImg: DEFAULT_HOUSE_PREVIEW
        };
    },
    components: {
        VerifyMask,
        PriceMask
    },
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    computed: {

        ...rootMapState(useUserStore, {
            "userEmailVerified": "userEmailVerified"
        }),

        ...rootMapState(usePageStore, {
            currencySymbol: store => store.currency.symbol,
            //fix AM-292489
            showSoldPrice: function(store) {
                let { mlsOrg } = this.params || {}
                let houseForMls =  store.page.mlsOrgs?.find?.(mls => mls.id === mlsOrg.id) || { showSoldPrice: 1 }
                let showSoldPrice = store.page.house?.showSoldPrice && houseForMls.showSoldPrice;
                return showSoldPrice
            }
        }),

        ...mapState({
            "showListingPrice": store => store.showListingPrice,
            "isSoldListing": "isSoldListing"
        }),
        
        //fix AM-292489
        
        
        
        changePriceNum() {
            const num = this.cellData.change;
            let targetNum = numberFormat(num, true, 0);
            if (targetNum.indexOf('M') > -1) {
                //  by M One decimal place for units 
                targetNum = numberFormat(num, true, 1);
            }
            return this.currencySymbol + targetNum;
        },
        //  Whether to display the price 
        showPrice() {
            return (
                !this.isSoldListing ||
                (this.isSoldListing && this.showSoldPrice)
            );
        },
        isShowMask() {
            const { listingStatus, mlsOrg } = this.params
            // soldProtected like "Sold,Active,Pending"
            const curSoldProtected = mlsOrg.soldProtected || ''
            const isVow = curSoldProtected.includes(listingStatus)
            return isVow && !this.userEmailVerified
        },
        //  process the displayed data 
        cellData() {
            const {
                previewPicture,
                picturesNum,
                address,
                propertyType,
                propertyTypeText,
                bedrooms,
                bathrooms,
                listingProvided,
                mlsOrg: { smallLogo }
            } = this.params;

            const { change, showPrice, link, listDate } =
                this.handleDataForListingType(this.params);

            const sqft = getSqftText.call(this, this.params);
            // data.propertyType == 'Vacant Land'
            //  deal with  sold listing  and  listing  Case 

            //  deal with  propertyType  yes  Vacant Land Case 

            let status = change === 0 ? 0 : change > 0 ? 1 : -1;
            // const change =
            return {
                link,
                previewPicture,
                change: Math.abs(change),
                status,
                picturesNum,
                address,
                listDate,
                propertyType: propertyTypeText || propertyType,
                bedrooms: bedrooms < 0 ? '-' : bedrooms,
                bathrooms: bathrooms < 0 ? '-' : bathrooms,
                sqft,
                showPrice,
                listingProvided,
                smallLogo
            };
        }
    },
    methods: {
        getDate(date) {
            let fmtdate = this.$ft.formatDate(new Date(date), 'MM/dd/yyyy');
            let d = this.$t('md-listing-list.soldOn', {
                date: fmtdate,
                interpolation: { escapeValue: false } 
            });
            return d;
        },
        //  for impression data  listing  and sold listing  Handling of different situations 
        handleDataForListingType(params) {
            const {
                listingStatus,
                soldPrice,
                price,
                id,
                oldPrice,
                soldDate,
                mlsListDateLSort,
                detailUrl
            } = params;
            let change, showPrice, link, listDate;
            if (listingStatus === 'Sold') {
                change = soldPrice - price;
                showPrice = soldPrice;
                listDate = soldDate;
                if (this.isShowMask) {
                    link = buildUrl({
                        name: 'sold-detail',
                        params: {
                            id,
                            address: 'address'
                        }
                    });
                } else {
                    link = detailUrl;
                }
            } else {
                change = Number(oldPrice) ? price - Number(oldPrice) : 0;
                showPrice = price;
                listDate = mlsListDateLSort * 1000;
                if (this.isShowMask) {
                    link = buildUrl({ name: 'listing-detail', params: { id, address: 'address' }, });
                } else {
                    link = detailUrl;
                }
            }
            return { change, showPrice, link, listDate };
        },
        goDetailPage() {
            window.location.href = this.cellData.link;
        }
    }
};
